/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    column: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: theme.spacing(36.65),
      minWidth: theme.spacing(32),
      "&~&": {
        marginLeft: theme.spacing(2),
      },
    },
    row: {
      display: "flex",
      flexDirection: "column",
      paddingTop: theme.spacing(2),
    },
    date: {
      color: "#333333",
      opacity: 0.5,
      fontSize: "12px",
      lineHeight: "20px",
    },
    content: {
      "&>a": {
        cursor: "pointer",
        fontSize: "14px",
        lineHeight: "22px",
        textDecorationLine: "underline",
        color: "#1C8AB5",
        "&:hover": {
          color: "#21A0D2",
        },
        "&:visited": {
          color: "#006c97",
        },
      },
    },
    image: {
      paddingRight: theme.spacing(1),
    },
  });

export const useStyles = makeStyles(styles);
